module.exports = __webpack_public_path__ + "img/banner2.1a1b51a4.png";